import React, { FC, memo } from "react";
import { Translate } from "@montana/shared/translate";
import { IOrderPersonalInformation, IOrderPickupLocation } from "@montana/models/generated/cms.interface";

interface IInformationSummaries {
    personalInfo?: IOrderPersonalInformation;
    pickUpAddress?: IOrderPickupLocation;
    expectedDelivery?: string;
    courier?: string;
}

export const InformationSummaries: FC<IInformationSummaries> = memo((props: IInformationSummaries) => {
    const { personalInfo, pickUpAddress, expectedDelivery, courier } = props;

    return (
        <section className="information-summaries-details">
            <div className="information-summaries-heading">
                <Translate value="checkoutPage.personalInformationHeading" defaultValue="[Personal Information]" />
            </div>
            <div>
                {personalInfo?.fullName}
            </div>
            <div>
                <Translate value="checkoutPage.personalInformationEmail" defaultValue="[E-mail:]" />
                <span className="information-summaries-details__spacing">{personalInfo?.email}</span>
            </div>
            <div className="information-summaries-details__phone">
                <Translate value="checkoutPage.personalInformationPhone" defaultValue="[Phone:]" />
                <span className="information-summaries-details__spacing">{personalInfo?.phone}</span>
            </div>
            <div>
                {personalInfo?.street}
            </div>
            <div>
                {personalInfo?.zipCode} {personalInfo?.city}
            </div>
            <div>
                {personalInfo?.country}
            </div>
            <div className="information-summaries-heading">
                <Translate value="checkoutPage.confirmationPickUpHeading" defaultValue="[Pick up location]" />
            </div>
            <div>
                {pickUpAddress?.glsParcelShopCompanyName}
            </div>
            <div>
                {pickUpAddress?.address}
            </div>
            <div>
                {pickUpAddress?.zipCode} {pickUpAddress?.city}
            </div>
            <div>
                {pickUpAddress?.country}
            </div>
            {!!expectedDelivery || !!courier && (
                <div className="information-summaries-heading">
                    <Translate value="checkoutPage.confirmationDeliveryInfoHeading" defaultValue="[Delivery information]" />
                </div>
            )}
            {!!expectedDelivery && (
                <div>
                    <Translate value="checkoutPage.confirmationExpectedDelivery" defaultValue="[expected delivery:]" />
                    <span className="information-summaries-details__spacing">{expectedDelivery}</span>
                </div>
            )}
            {!!courier && (
                <div>
                    <Translate value="checkoutPage.confirmationCourier" defaultValue="[Courier:]" />
                    <span className="information-summaries-details__spacing">{courier}</span>
                </div>
            )}
        </section>
    );
});
